/**
 * Background Zoom Out
 * Scales the background media back to 1 when its section/group enters the viewport.
 */
(() => {
  // The script tag is rendered once per section/group using it, so guard against multiple executions.
  if (window.backgroundZoomOutLoaded) return;
  window.backgroundZoomOutLoaded = true;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -50px 0px' }
  );

  const initBackgroundZoomOut = () => {
    document.querySelectorAll('.background-zoom-out:not(.is-visible)').forEach((el) => observer.observe(el));
  };

  initBackgroundZoomOut();

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', initBackgroundZoomOut);
  }
})();
